import React, { useRef } from 'react'
import './index.scss'
import classnames from 'classnames'
import LazyLoad from 'react-lazyload'
import { useTranslation  } from '../../i18n'
export interface IImageModel {
  full?: any
  thumbnail?: any
}

export interface IProductModel {
  colors: any[]
  displayBrand: string
  brand: string
  originalPriceTag: string
  priceTagCN: string
  priceTag: string
  images: IImageModel[]
  officialURL?: string
}

export interface IRankProdutModel {
  product: IProductModel | any
  origin: string
  merchantName: string
  favoritedCount: number
  activityOffs: string[]
}

export interface IProductProps {
  productInfo: IRankProdutModel | any
  className?: string
  clickTo?: (type, path1, path2, componentId, officialURL?: string) => void
  index: number
  pid?: string
  sizeSeat?: boolean
}

const getImgPath = (images) => {
  if (images === void 0 || images.length === 0) {
    return ''
  }
  if (images[0].thumbnail !== void 0 && images[0].thumbnail.url !== void 0) {
    return images[0].thumbnail.url + '?x-oss-process=image/resize,l_300'
  } else if (images[0].full !== void 0 && images[0].full.url !== void 0) {
    return images[0].full.url + '?x-oss-process=image/resize,l_300'
  }
  return ''
}
const Product3: React.FC<IProductProps> = (props: IProductProps) => {
  const { t } = useTranslation()
  const mountProduct3: any = useRef()
  const { productInfo, index, className, clickTo, pid, sizeSeat } = props
  const { product, off, activityOffs } = productInfo || {}
  const classes = classnames('lego_product3', className)
  const productName =
    (product?.displayBrand
      ? `${product?.displayBrand} | `
      : `${product?.brand} | `) + (product?.nameCN || product?.name)
  if (!productInfo || productInfo.sizeSeat) {
    return (
      <div className={classes} style={{ backgroundColor: 'transparent' }}></div>
    )
  }
  return (
    <div
      ref={mountProduct3}
      className={classes}
      onClick={() =>
        clickTo('product', product.id, '', pid, product.officialURL)
      }
      data-productid={product.id}
      data-pid={pid}
      data-id={product.id}
      data-index={index}
    >
      <div className="imgBox">
        <LazyLoad
          classNamePrefix="product3_imgBox_img"
          overflow={true}
          height={50}
        >
          <img src={getImgPath(product.images)} className="realImg" />
        </LazyLoad>
        {product.inventoryStatus !== 'AVAILABLE' && (
          <div className="selloutContent">{ t('SOLD_OUT') }</div>
        )}
      </div>
      <div className="productInfoContent">
        <div className="productName">{productName}</div>
        <div className="priceAm">
          <div
            className={`originalPriceCn ${
              product.originalPriceTag ? 'blueColor' : ''
            }`}
          >
            {product.priceTagCN}
          </div>
        </div>
      </div>
      {(off || activityOffs?.length > 0) && (
        <div className="promoMsg">
          {off && <span className="promoItem off">{off}</span>}
          {activityOffs.map((val, index) => {
            {
              return (
                <span className="promoItem" key={`off${index}`}>
                  {val}
                </span>
              )
            }
          })}
        </div>
      )}
    </div>
  )
}

export default Product3
